import React from 'react';
import { connect } from 'react-redux'
import IconButton from "@material-ui/core/IconButton";
import { MdArrowBack, MdClear } from 'react-icons/md';
import NumberFormat from 'react-number-format';

// Local imports
import FinancialContractualServiceEditPage from "./FinancialContractualServiceEditPage";
import { FinancialInformationalCards, FinancialInformationalCardsMobile } from './FinancialInformationalCards';

import {
    getQuarterAmountByAmountType,
    splitAmountIntoWholeNumberAndDecimal,
    calculateAmount,
    getNonDeletedItems,
    getAwardedTotal,
    calculateRemainingFederal
} from './FinancialCommonApi';


// Component imports
import { DualTitleHeaderComponent } from "../../layout/HeaderComponent.js";
import { PrimaryButton } from "../../styled-components/Buttons/Buttons.js";
import { CardComponent2R1C } from "../../layout/CardComponent.js";

//Redux import

import { setCurrentQuarterlyItem } from "../../../redux/actions/index";

// CSS imports
import "../../../styles/common.css";
import "../../../styles/iron-flex-layout.css";
import "../../../styles/iron-flex-layout-classes.css";

const mapStateToProps = (state) => {
    return {
        selectedCounty: state.rootReducer.selectedCounty,
        currentQuarter: state.rootReducer.currentQuarter,
        grantApplication: state.rootReducer.grantApplication,
        currentApplicationState: state.rootReducer.currentApplicationState,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentQuarterlyItem: (payload) => dispatch(setCurrentQuarterlyItem(payload)),
    }
};

class FinancialContractualService extends React.Component {

    state = {
        contractualService: (this.props.currentQuarter && this.props.currentQuarter.contractualService && this.props.currentQuarter.contractualService && this.props.currentQuarter.contractualService.items) || [],
        showEditPage: false,
    }

    constructor(props, context) {
        super(props, context);
        this.goBack = this.goBack.bind(this);
    }

    showEditPage = (event) => {
        this.state.showEditPage = true;
        this.setState({ "showEditPage": this.state.showEditPage });
    }

    showItems = () => {
        this.state.showEditPage = false;
        this.setState({ "showEditPage": this.state.showEditPage });
    }

    addContractualService = () => {
        this.state.id = "";
        this.state.positionTitle = "";
        this.state.files = [];
        this.state.quarterAmount = "";
        this.state.matchAmount = "";
        this.state.taxAmount = "";
        this.state.deleted = false;
        this.showEditPage();
    }

    goBack() {
        this.props.history.goBack();
    }

    componentDidUpdate() { }

    getContractualServiceItems = (type) => {

        var items = this.props.grantApplication && this.props.grantApplication[type] && this.props.grantApplication[type].items || [];

        var remainingItems = []

        items.forEach((item) => {
            if (!item.deleted) {
                var found = false
                this.state.contractualService.forEach((contractualService) => {
                    if ((item.name === contractualService.positionTitle) && !contractualService.deleted && !item.deleted) {
                        found = true
                    }
                });
                if (!found) remainingItems.push(item)
            }
        })

        return remainingItems;

    }

    getContractualServiceItem = (item) => {
        // this.props.setCurrentQuarterlyItem(item)
        this.state.id = item.id;
        this.state.positionTitle = item.positionTitle;
        this.state.files = JSON.parse(item.file);
        this.state.quarterAmount = item.quarterAmount;
        this.state.matchAmount = item.matchAmount;
        this.state.taxAmount = item.taxAmount;
        this.state.deleted = item.deleted;
        this.state.validate = false;
        this.state.errors = [];
        this.showEditPage();
    }

    getNonDeletedItems = (items) => {
        var arr = []

        items.forEach((item) => {
            if (!item.deleted) arr.push(item)
        })

        return arr.length;
    }


    /**
     * 
     * This is a feeder function for showing types of informational cards being displayed
     * The calculation for these cards might depend on some functions defined in FinancialCommonApi
     * 
     */


    getInformationalCardInformation = (currentQuarter) => {
        let informationalCards = [];
        let count = 0;
        // contractualService amount awarded

        let federalShareTotal = getQuarterAmountByAmountType(this.props.currentQuarter, ["contractualService"], "quarterAmount");

        let remaining = calculateRemainingFederal(this.props).types['contractualService'];
  
        let { whole, decimal } = splitAmountIntoWholeNumberAndDecimal(remaining);
  
        informationalCards.push({
            id: count++,
            title: "CONTRACTUAL SERVICE AMT. AWARDED",
            amount1: whole,
            amount2: decimal ? ("." + decimal) : "",
            class: remaining > 0 ? "informational-card-text-color-safe" : "informational-card-text-color-danger",
        })

        let { whole: federalShareTotalWhole, decimal: federalShareTotalDecimal } = splitAmountIntoWholeNumberAndDecimal(federalShareTotal)


        informationalCards.push({
            id: count++,
            title: "FED SHARE TOTAL",
            amount1: federalShareTotalWhole,
            amount2: federalShareTotalDecimal ? ("." + federalShareTotalDecimal) : "",
            class: "informational-card-text-color-safe",
        })


        // county share total

        let countyShareTotal = getQuarterAmountByAmountType(this.props.currentQuarter, ["contractualService"], "matchAmount");

        let { whole: countyShareTotalWhole, decimal: countyShareTotalDecimal } = splitAmountIntoWholeNumberAndDecimal(countyShareTotal)

        informationalCards.push({
            id: count++,
            title: "COUNTY SHARE TOTAL",
            amount1: countyShareTotalWhole,
            amount2: countyShareTotalDecimal ? ("." + countyShareTotalDecimal) : "",
            class: "informational-card-text-color-safe",
        })


        // overmatch

        let overmatch = (countyShareTotal - federalShareTotal);
        let { whole: overmatchWhole, decimal: overmatchDecimal } = splitAmountIntoWholeNumberAndDecimal(overmatch)

        informationalCards.push({
            id: count++,
            title: "OVERMATCH",
            amount1: overmatchWhole,
            amount2: (overmatchDecimal ? ("." + overmatchDecimal) : ""),
            hideLine: true,
            class: federalShareTotal > countyShareTotal ? "informational-card-text-color-info" : "informational-card-text-color-safe",
        })


        return informationalCards;
    }       

    render() {

        const quarterSubheaderTitle = "Q" + parseInt(this.props.currentQuarter.quarter.split("").reverse())

        const ContractualServiceList = (props) => {
            return (
                <div className="layout vertical full-height">
                    <div className="flex container-overflow-y">
                        {
                            this.state.contractualService.map((item, index) => {
                                if (!item.deleted) {
                                    return (
                                        <div key={item.id} className="layout horizontal cursor-pointer" onClick={() => this.getContractualServiceItem(item)}>
                                            <CardComponent2R1C
                                                className="flex no-opacity-important-childs"
                                                title={<span style={{ textTransform: "capitalize" }}>{item.positionTitle}</span>}
                                                title2={<span className="title-54-14">
                                                    <NumberFormat value={calculateAmount(this.state.contractualService, item)} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                                </span>}
                                            />
                                        </div>
                                    )
                                }
                            })
                        }
                    </div>

                    <div className="layout horizontal margin-16">
                        <div className="flex"></div>
                        {
                            this.getContractualServiceItems('contractualService').length > 0 ?
                                <PrimaryButton setwidth="true" onClick={() => this.addContractualService()}> Add Contractual Service </PrimaryButton>
                                : ""
                        }
                    </div>
                </div>
            )
        }

        const EmptyState = (props) => {
            return (
                <div className="layout vertical full-height">
                    <div className="layout vertical flex  vertical-center">
                        <span className="text-center title-87-24">No contractual services  added</span>
                        <span className="text-center title-54-16 line-height-15">Select add contractual service button below to get started</span>
                    </div>

                    <div className="layout horizontal margin-16">
                        <div className="flex"></div>
                        {
                            this.getContractualServiceItems('contractualService').length > 0 ?
                                <PrimaryButton setwidth="true" onClick={() => this.addContractualService()}> Add Contractual Service </PrimaryButton>
                                : ""
                        }
                    </div>
                </div>
            )
        }

        return (

            this.state.showEditPage ? <FinancialContractualServiceEditPage showItems={this.showItems} getItems={this.getContractualServiceItems} {...this.state} />
                :
                <div className="layout vertical full-height">

                    <DualTitleHeaderComponent
                        icon={
                            <IconButton
                                aria-label="close"
                                onClick={this.goBack}
                            >
                                <MdArrowBack className="icon" />
                            </IconButton>

                        }
                        titleBig={<span> Contractual Service </span>}
                        titleSmall={<span style={{ textTransform: "capitalize" }}>{quarterSubheaderTitle}  • {this.props.selectedCounty && this.props.selectedCounty.groupName}</span>}
                        suffix={
                            <FinancialInformationalCardsMobile items={this.getInformationalCardInformation(this.props.currentQuarter)} />
                        }
                    />

                    <FinancialInformationalCards items={this.getInformationalCardInformation(this.props.currentQuarter)} />

                    <div className="flex container-overflow-y">

                        {
                            this.state.contractualService && this.state.contractualService.length && getNonDeletedItems(this.state.contractualService) > 0 ? <ContractualServiceList /> : <EmptyState {...this.props} />

                        }

                    </div>


                </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FinancialContractualService);
